<template>
    <b-tooltip v-if="src.length > 0" :label="ciService" position="is-bottom" type="is-dark">
        <img class="ci-service-icon" :src="src" :alt="ciService">
    </b-tooltip>
</template>

<script>
import BbIcon from "@/assets/bb_icon.png";
import JenkinsIcon from "@/assets/jenkins_icon.png";
import JenkinsBuildBotIcon from "@/assets/jenkins_buildbot_icon.png";

export default {
    name: "CiServiceIcon",
    props: {
        ciService: String,
    },
    computed: {
        src() {
            switch(this.ciService) {
                case 'BuildBot':
                    return BbIcon;
                case 'Jenkins':
                    return JenkinsIcon;
                case 'JenkinsBuildbot':
                      return JenkinsBuildBotIcon;
                default:
                    return '';
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.ci-service-icon {
    max-width: 44px;
    max-height: 24px;
}
</style>